export const RESTORE_COLLI_INIT = 'RESTORE_COLLI_INIT';
export const RESTORE_COLLI_START = 'RESTORE_COLLI_START';
export const RESTORE_COLLI_SUCCESS = 'RESTORE_COLLI_SUCCESS';
export const RESTORE_COLLI_FAIL = 'RESTORE_COLLI_FAIL';
